module.exports = __webpack_public_path__ + "static/media/exportar.9e7dc1e3.png";